import { type FC, useEffect, useRef } from 'react';
import analytics from '../analytics';
import { t } from '../i18n';
import { GeolocationStatus, useStore } from '../store';

export const OwnLocationManager: FC = () => {
  const watchId = useRef<number | null>(null);
  const geolocationStatus = useStore((state) => state.timer.geolocation.status);
  const setGeolocationStatus = useStore((state) => state.actions.setGeolocationStatus);
  const setOwnLocation = useStore((state) => state.actions.setOwnLocation);

  function cancel() {
    if (watchId.current == null) return;

    window.navigator.geolocation.clearWatch(watchId.current);
    watchId.current = null;
    setGeolocationStatus(GeolocationStatus.OFF);
    setOwnLocation(null);
  }

  useEffect(() => {
    if (geolocationStatus === GeolocationStatus.SEARCHING) {
      watchId.current = window.navigator.geolocation.watchPosition(
        (position) => {
          if (position != null && position.coords != null) {
            const latlng = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
              opacity: 1,
            };
            setGeolocationStatus(GeolocationStatus.FOLLOWING);
            setOwnLocation(latlng);
            analytics.send('geolocation-success');
          } else {
            analytics.send('geolocation-fail');
          }
        },
        () => {
          cancel();
          alert(t("We couldn't determine your position"));
          analytics.send('geolocation-fail');
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
        },
      );
    } else if (geolocationStatus === 'OFF' && watchId.current != null) {
      cancel();
    }
  }, [geolocationStatus]);

  return null;
};
